export default "__VITE_ASSET__CNISCZyu__"